<!-- 决赛 -->
<template>
    <div v-if="isAfter(finalRes)" class="stage-mod stage-final-result">
        <div class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                <dl v-if="isAfter(finalRes) && myAwards">
                    <dd v-if="finalRank">你在决赛中排名
                        <k-txt-rank :value="finalRank" />, 初赛中排名
                        <k-txt-rank :value="preRank" />
                    </dd>
                    <dd v-else>你在初赛中排名
                        <k-txt-rank :value="preRank" />
                    </dd>
                    <dd v-if="myAwards.length > 1">获得了<span class="red">{{myAwards[0].name}}</span>等奖项</dd>
                    <dd v-else>获得了<span class="red">{{myAwards[0].name}}</span></dd>
                    <dd><a class="blue" href="javascript:;" @click="goView">立即查看</a></dd>
                </dl>
                <dl v-else-if="isFinishFinal">
                    <dd>你的决赛排名
                        <k-txt-rank :value="finalRank" />，得分<span class="cl_danger">{{finalScore}}</span></dd>
                    <dd>初赛排名
                        <k-txt-rank :value="preRank" />，得分<span class="cl_danger">{{preScore}}</span></dd>
                    <dd><a class="blue" href="javascript:;" @click="goView">立即查看</a></dd>
                </dl>
                <dl v-else-if="isAdvance">
                    <dd v-if="preScore">初赛排名
                        <k-txt-rank :value="preRank" />，得分<span class="cl_danger">{{preScore}}</span></dd>
                    <dd v-else>&nbsp;</dd>
                    <dd>很遗憾您没有完成决赛，决成绩失效！</dd>
                    <!-- <dd>您可以关注下次活动，再次参与！</dd> -->
                    <dd><a class="blue" href="javascript:;" @click="goView">立即查看</a></dd>
                </dl>
                <dl v-else>
                    <dd>{{finalRes|time2text}}公布初赛成绩、获奖名单</dd>
                    <dd><a class="blue" href="javascript:;" @click="goView">立即查看</a></dd>
                </dl>
            </div>
            <div class="stage-box__btns">
            <van-row gutter="5">
                <van-col span="12"><van-button class="btnX2" size="normal" block type="danger" @click="goDouK">斗K训练</van-button></van-col>
                <van-col span="12"><van-button class="btnX2" size="normal" block type="warning" @click="goTrialDK">斗K体验</van-button></van-col>
            </van-row>
            </div>
            
        </div>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    import {
        getStorage,
        setStorage
    } from '../../../common/utils'
    const STORE_KEY = 'match_award_dlg'
    export default {
        name: 'final-result',
        computed: {
            ...mapState(['myAwards']),
            ...mapGetters(['finalBegin', 'awardTime', 'isAdvance', 'finalRes', 'finishCupNum', 'allCupNum', 'finalRank',
                'finalScore', 'preRank', 'preScore',
                'isFinishFinal', 'isAfter', 'isValidUser', 'myFinalAwards'
            ]),
            canAlertFinalAward() {
                return this.myFinalAwards && getStorage(STORE_KEY) !== 'final'
            }
        },
        methods: {
            ...mapActions(['goLogin', 'goTrialDK', 'goDouK']),
            goView() {
                if (this.isAfter(this.finalRes) && this.myAwards) {
                    this.$router.push("/match/my/awards")
                } else {
                    this.$router.push("/match/final")
                }
                // if(this.isValidUser) {
                // this.$router.push("/match/final")
                // } else {
                //     this.$dialog.alert({
                //         title: '参赛提醒',
                //         message: '<div class="ta_left">尊敬的用户您好！<br>为保证您的比赛成绩留存及奖项核实发放，<span class="blue">验证手机号即可参与大赛</span>。</div>',
                //         // cancelButtonText: '取消',
                //         confirmButtonText: '验证手机号'
                //     }).then(() => {
                //         this.goLogin()
                //         // on confirm
                //     // }).catch(() => {
                //         // on cancel
                //     });
                // }
            },
            async alertFinalAward() {
                if (this.canAlertFinalAward) {
                    await this.$dialog.alert({
                        title: '获奖通知',
                        message: '<div class="ta_left">尊敬的用户你好，<br>决赛成绩已公布，恭喜你在决赛中获奖啦！<br>快去看看获得了哪些奖项吧！</div>',
                        confirmButtonText: '查看详情'
                    })
                    this.$router.push('/match/my/awards')
                    setStorage(STORE_KEY, 'final')
                }
            }
        },
        watch: {
            myFinalAwards() {
                if (this.canAlertFinalAward) {
                    this.alertFinalAward()
                }
            }
        },
        created() {
            if (this.canAlertFinalAward) {
                this.alertFinalAward()
            }
        }
    }

</script>
